/**
 * lottie组件
 */
import React, { useEffect, useRef, useState } from 'react';
import './dynamicCard.scss';
import lottie from 'lottie-web';
let isHover = false;

const DynamicCard = (props) => {
  const lottieEl = useRef(null);
  let [animationInstance, setInstance] = useState(null);
  const { lottieData } = props;

  const handleMouseover = () => {
    if (!animationInstance) return;
    animationInstance.playSegments([0, 15], true);
    isHover = true;
  };

  const handleMouseout = () => {
    if (!animationInstance) return;
    animationInstance.playSegments([15, 0], true);
    isHover = false;
  };
  useEffect(() => {
    let animation = lottie.loadAnimation({
      container: lottieEl.current, // the dom element that will contain the animation
      renderer: 'svg',
      name: 'd-card',
      autoplay: false,
      animationData: lottieData.data,
      assetsPath: lottieData.assetPath,
    });
    setInstance(animation);
    const loopCallback = () => {
      if (!animation) {
        return;
      }
      if (isHover) {
        animation.goToAndStop(15, true);
      } else {
        animation.goToAndStop(0, true);
      }
    };
    animation.addEventListener('loopComplete', loopCallback);
  }, []);

  return (
    <div
      className='d-card'
      ref={lottieEl}
      onMouseEnter={handleMouseover}
      onMouseLeave={handleMouseout}
    />
  );
};

export default DynamicCard;
